import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const Markdown = ({ content }) => {
  return (
    <div className="prose prose-invert max-w-none">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({node, ...props}) => <h1 className="text-2xl font-black italic tracking-tighter mb-4 uppercase" {...props} />,
          h2: ({node, ...props}) => <h2 className="text-xl font-bold mb-3 uppercase" {...props} />,
          p: ({node, ...props}) => <p className="text-slate-400 mb-4 leading-relaxed" {...props} />,
          ul: ({node, ordered, ...props}) => <ul className="list-disc list-inside mb-4 text-slate-400 marker:text-[#a3e635]" {...props} />,
          ol: ({node, ordered, ...props}) => <ol className="list-decimal list-inside mb-4 text-slate-400 marker:text-[#a3e635]" {...props} />,
          li: ({node, ordered, children, ...props}) => {
            // Check if any child is a string that starts with an emoji
            // Or if children is a single string starting with one
            const content = Array.isArray(children) ? children : [children];
            // Regex to detect if a string starts with an emoji
            // This is a broad emoji regex
            const emojiRegex = /^\p{Emoji}/u;
            
            const startsWithEmoji = content.some(child => 
              typeof child === 'string' && emojiRegex.test(child.trim())
            );
            
            return (
              <li 
                className={`mb-1 ${startsWithEmoji ? 'list-none relative pl-0' : ''}`} 
                {...props}
              >
                {children}
              </li>
            );
          },
          strong: ({node, ...props}) => <strong className="text-white font-bold" {...props} />,
          table: ({node, ...props}) => (
            <div className="overflow-x-auto mb-6">
              <table className="w-full text-left border-collapse bg-slate-900/50 rounded-2xl overflow-hidden" {...props} />
            </div>
          ),
          thead: ({node, ...props}) => <thead className="bg-slate-800/80 text-[#a3e635] uppercase text-[10px] font-black tracking-widest" {...props} />,
          th: ({node, ...props}) => <th className="px-4 py-3 border-b border-slate-700/50" {...props} />,
          td: ({node, ...props}) => <td className="px-4 py-3 border-b border-slate-700/50 text-slate-300 text-sm" {...props} />,
          tr: ({node, ...props}) => <tr className="hover:bg-slate-800/30 transition-colors" {...props} />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default Markdown;
